module.exports = __webpack_public_path__ + "static/img/logo.881b24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo.png
// module id = INMq
// module chunks = 1